import { render, staticRenderFns } from "./SalesView.vue?vue&type=template&id=4dc592cc&scoped=true"
import script from "./SalesView.vue?vue&type=script&lang=js"
export * from "./SalesView.vue?vue&type=script&lang=js"
import style0 from "./SalesView.vue?vue&type=style&index=0&id=4dc592cc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dc592cc",
  null
  
)

export default component.exports